module.exports = __webpack_public_path__ + "static/media/YB5M11_1.574ab59b.jpg";